<div
    class="vertical-navigation-item"
    [ngClass]="{ 'vertical-navigation-item--last': isLastItem() }"
    data-testid="header-vertical-navigaton-item"
>
    <ap-menu-item [navigationItem]="navigationItem()" [includeParent]="true" (navigationClicked)="navigationClicked.emit($event)">
    </ap-menu-item>
</div>
